import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import styles from "../../../InfoCliniche/InfoCliniche.module.css";
import RadioButton from "../../../../../../components/radiobutton/RadioButton";
import Input from "../../../../../../components/textbox/Input";
import Calendar from "../../../../../../components/calendar/Calendar";
import Utils from "../../../../../../utils/Utils";
import OggettiUtili from "../../../../../../utils/OggettiUtili.json"

class DatiDiLaboratorio extends Component {
    state = {
        datiDiLaboratorio: {
            dataPrelievo: "",
            igmHev: "",
            iggHev: "",
            hevRnaSiero: "",
            hevRnaFeci: "",
            genotipo: "",
            astGpt: "",
            bilirubinaTotale: "",
            altGot: "",
            bilirubinaDiretta: "",
            antiHbc: "",
            igmHav: "",
            igmHbc: "",
            hcv: "",
            hbsAg: "",
            hcvRna: "",
            corretto: []

        },
        propsDataSintomi: "",
        propsDataDecesso: ""
    }

    constructor(props) {
        super(props);
        this.riceviValoreInput = this.riceviValoreInput.bind(this);
        this.pulisciValori = this.pulisciValori.bind(this);
        this.validate = this.validate.bind(this);
    }

    componentDidMount() {

        let newState = this.state.datiDiLaboratorio;
        if (this.props.segnalazioneCopia && this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.datiDiLaboratorio) {
            let datiDiLaboratorioCopia = this.props.segnalazioneCopia.schedaSpeciale.datiDiLaboratorio;
            newState.dataPrelievo = datiDiLaboratorioCopia.dataPrelievo ? datiDiLaboratorioCopia.dataPrelievo : "";
            newState.igmHev = datiDiLaboratorioCopia.igmHev ? datiDiLaboratorioCopia.igmHev : "";
            newState.iggHev = datiDiLaboratorioCopia.iggHev ? datiDiLaboratorioCopia.iggHev : "";
            newState.hevRnaSiero = datiDiLaboratorioCopia.hevRnaSiero ? datiDiLaboratorioCopia.hevRnaSiero : "";
            newState.hevRnaFeci = datiDiLaboratorioCopia.hevRnaFeci ? datiDiLaboratorioCopia.hevRnaFeci : "";
            newState.genotipo = datiDiLaboratorioCopia.genotipo ? datiDiLaboratorioCopia.genotipo : "";
            newState.astGpt = datiDiLaboratorioCopia.astGpt ? datiDiLaboratorioCopia.astGpt : "";
            newState.bilirubinaTotale = datiDiLaboratorioCopia.bilirubinaTotale ? datiDiLaboratorioCopia.bilirubinaTotale : "";
            newState.altGot = datiDiLaboratorioCopia.altGot ? datiDiLaboratorioCopia.altGot : "";
            newState.bilirubinaDiretta = datiDiLaboratorioCopia.bilirubinaDiretta ? datiDiLaboratorioCopia.bilirubinaDiretta : "";
            newState.antiHbc = datiDiLaboratorioCopia.antiHbc ? datiDiLaboratorioCopia.antiHbc : "";
            newState.igmHav = datiDiLaboratorioCopia.igmHav ? datiDiLaboratorioCopia.igmHav : "";
            newState.igmHbc = datiDiLaboratorioCopia.igmHbc ? datiDiLaboratorioCopia.igmHbc : "";
            newState.hcv = datiDiLaboratorioCopia.hcv ? datiDiLaboratorioCopia.hcv : "";
            newState.hbsAg = datiDiLaboratorioCopia.hbsAg ? datiDiLaboratorioCopia.hbsAg : "";
            newState.hcvRna = datiDiLaboratorioCopia.hcvRna ? datiDiLaboratorioCopia.hcvRna : "";
        }
        let newPropsDataSintomi = this.props.dataSintomi ? this.props.dataSintomi : "";
        let newPropsDataDecesso = this.props.dataDecesso ? this.props.dataDecesso : "";
        this.setState({
            datiDiLaboratorio: newState,
            propsDataSintomi: newPropsDataSintomi,
            propsDataDecesso: newPropsDataDecesso
        });
        this.controlloDati();
        let objectForBackend = Object.assign({}, Utils.removeFieldFromObject({...this.state.datiDiLaboratorio}, "corretto"))
        this.props.setStatePadre(newState, "datiDiLaboratorio", objectForBackend, this.validate())
    }

    riceviValoreInput(field, event) {
        let newState = this.state.datiDiLaboratorio;
        if (field && field.target && field.target.id) {
            newState[field.target.id] = field.target.value;
        } else {
            newState[field] = event.target.value;
        }
        let newStatePulito = this.pulisciValori(newState);
        this.setState({datiDiLaboratorio: newStatePulito})
        this.controlloDati();
        let objectForBackend = Object.assign({}, Utils.removeFieldFromObject({...this.state.datiDiLaboratorio}, "corretto"))
        this.props.setStatePadre(newStatePulito, "datiDiLaboratorio", objectForBackend, this.validate())
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if ((prevProps.dataDecesso !== this.props.dataDecesso) || (prevProps.dataSintomi !== this.props.dataSintomi)) {
            if (this.state.propsDataSintomi !== this.props.dataSintomi || this.state.propsDataDecesso !== this.props.dataDecesso) {
                let newState = this.state.datiDiLaboratorio;
                let newStatePulito = this.pulisciValori(newState);
                let objectForBackend = Object.assign({}, Utils.removeFieldFromObject({...this.state.datiDiLaboratorio}, "corretto"))
                this.props.setStatePadre(newStatePulito, "datiDiLaboratorio", objectForBackend, this.validate());
            }
        }
    }

    pulisciValori(state) {
        if ((state.hevRnaSiero !== "01") || (state.hevRnaFeci !== "01")) {
            state.genotipo = "";
        }
        return state;

    }

    validate() {

        if (this.state.datiDiLaboratorio.dataPrelievo && this.props.dataSintomi) {
            let validatedataPrelievo = Utils.checkDateInterval(this.state.datiDiLaboratorio.dataPrelievo, "31/12/1899");
            let validatedataPrelievoOdierna = Utils.checkDateInterval(this.state.datiDiLaboratorio.dataPrelievo, Utils.transformTimeStampForFrontend(Utils.getTodayDateTimestamp()));
            let confrontoSintomiPrelievo = Utils.checkDateInterval(this.props.dataSintomi, this.state.datiDiLaboratorio.dataPrelievo);

            if (validatedataPrelievo) {
                return "Messages.DataPrelievo"
            } else if (!validatedataPrelievoOdierna) {
                return "Messages.DataPrelievoOdierna"
            }

            if (!confrontoSintomiPrelievo) {
                return "Messages.ERR_01_02_0I_AU"
            }
        }
        if (this.state.datiDiLaboratorio.igmHev && this.state.datiDiLaboratorio.hevRnaSiero && this.state.datiDiLaboratorio.hevRnaFeci) {
            if ((this.state.datiDiLaboratorio.igmHev === "02") &&
                (this.state.datiDiLaboratorio.hevRnaFeci === "02" || this.state.datiDiLaboratorio.hevRnaFeci === "03") &&
                (this.state.datiDiLaboratorio.hevRnaSiero === "02" || this.state.datiDiLaboratorio.hevRnaSiero === "03")) {
                return "Messages.ERR_01_02_0I_BC"
            }
        }
        if (this.state.datiDiLaboratorio.dataPrelievo && this.props.dataDecesso) {
            let confrontoPrelievoDecesso = Utils.checkDateInterval(this.state.datiDiLaboratorio.dataPrelievo, this.props.dataDecesso);
            if (!confrontoPrelievoDecesso) {
                return "Messages.ERR_01_02_0I_BB"
            }
        }
        return ""
    }

    controlloDati() {
        let datiDiLaboratorio = this.state.datiDiLaboratorio;
        datiDiLaboratorio.corretto = [];
        const t = this.props
        if (datiDiLaboratorio.dataPrelievo && (Utils.isDateInValid(Utils.transformDateForBackend(datiDiLaboratorio.dataPrelievo), "-"))) datiDiLaboratorio.corretto[0] = "Campo \"Data prelievo\" errato";
        if (!datiDiLaboratorio.igmHev) datiDiLaboratorio.corretto[1] = "Campo \"IgM anti-HEV\" mancante";
        if (!datiDiLaboratorio.hevRnaSiero) datiDiLaboratorio.corretto[2] = "Campo \"HEV-RNA su siero\" mancante";
        if (!datiDiLaboratorio.hevRnaFeci) datiDiLaboratorio.corretto[3] = "Campo \"HEV-RNA su feci\" mancante";

        this.setState({datiDiLaboratorio: datiDiLaboratorio});

    }

    render() {
        const {t} = this.props
        return (
            <div>
                <div style={{marginTop: "10px"}}/>
                <div><h6>Dati di laboratorio</h6>
                    <hr className={styles.hr}/>
                </div>
                <div className={"container"}>
                    <div>
                        <div className={"row"}>
                            <div className={"col-lg-12 mt-1"}>
                                <div className={"row"}>
                                    <div className={`col-lg-4 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'visualizzazione livello1' : ''}`}>
                                        <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                            {t("SchedaSpecialeEpatiteE.DatiDiLaboratorio.dataPrelievo")}
                                        </p>
                                        <Calendar
                                            id={"dataPrelievo"}
                                            field={"dataPrelievo"}
                                            value={this.state.datiDiLaboratorio.dataPrelievo}
                                            onChange={this.riceviValoreInput}
                                            errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>",
                                                "Data")}
                                            error={(this.state.datiDiLaboratorio.dataPrelievo === "" ||
                                                this.state.datiDiLaboratorio.dataPrelievo == null) ? false :
                                                Utils.isDateInValid(Utils.transformDateForBackend(this.state.datiDiLaboratorio.dataPrelievo), "-")}
                                        >
                                        </Calendar>
                                    </div>
                                    <div className={"col-lg-4"}>
                                        <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                            {t("SchedaSpecialeEpatiteE.DatiDiLaboratorio.igmHev")}
                                            <span className={styles.mandatoryColor}>*</span>
                                        </p>
                                        <div className={"row"}>
                                            <RadioButton id={"igmHevSi"}
                                                         name={"igmHev"}
                                                         label={t("SchedaSpecialeEpatiteE.DatiDiLaboratorio.pos")}
                                                         value={"01"}
                                                         newRadio={true}
                                                         onClick={this.riceviValoreInput}
                                                         checked={this.state.datiDiLaboratorio.igmHev === "01"}
                                            />
                                            <RadioButton id={"igmHevNo"}
                                                         name={"igmHev"}
                                                         label={t("SchedaSpecialeEpatiteE.DatiDiLaboratorio.neg")}
                                                         value={"02"}
                                                         newRadio={true}
                                                         onClick={this.riceviValoreInput}
                                                         checked={this.state.datiDiLaboratorio.igmHev === "02"}
                                            />
                                            <RadioButton id={"igmHevNonSo"}
                                                         name={"igmHev"}
                                                         label={t("SchedaSpecialeEpatiteE.DatiDiLaboratorio.nonRicercato")}
                                                         value={"03"}
                                                         newRadio={true}
                                                         onClick={this.riceviValoreInput}
                                                         checked={this.state.datiDiLaboratorio.igmHev === "03"}
                                            />
                                        </div>
                                    </div>
                                    <div className={"col-lg-4"}>
                                        <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                            {t("SchedaSpecialeEpatiteE.DatiDiLaboratorio.iggHev")}
                                        </p>
                                        <div className={"row"}>
                                            <RadioButton id={"iggHevSi"}
                                                         name={"iggHev"}
                                                         label={t("SchedaSpecialeEpatiteE.DatiDiLaboratorio.pos")}
                                                         value={"01"}
                                                         newRadio={true}
                                                         onClick={this.riceviValoreInput}
                                                         checked={this.state.datiDiLaboratorio.iggHev === "01"}
                                            />
                                            <RadioButton id={"iggHevNo"}
                                                         name={"iggHev"}
                                                         label={t("SchedaSpecialeEpatiteE.DatiDiLaboratorio.neg")}
                                                         value={"02"}
                                                         newRadio={true}
                                                         onClick={this.riceviValoreInput}
                                                         checked={this.state.datiDiLaboratorio.iggHev === "02"}
                                            />
                                            <RadioButton id={"iggHevNonSo"}
                                                         name={"iggHev"}
                                                         label={t("SchedaSpecialeEpatiteE.DatiDiLaboratorio.nonRicercato")}
                                                         value={"03"}
                                                         newRadio={true}
                                                         onClick={this.riceviValoreInput}
                                                         checked={this.state.datiDiLaboratorio.iggHev === "03"}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className={"row"}>
                                    <div className={"col-lg-4"}>
                                        <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                            {t("SchedaSpecialeEpatiteE.DatiDiLaboratorio.hevRnaSiero")}
                                            <span className={styles.mandatoryColor}>*</span>
                                        </p>
                                        <div className={"row"}>
                                            <RadioButton id={"hevRnaSieroSi"}
                                                         name={"hevRnaSiero"}
                                                         label={t("SchedaSpecialeEpatiteE.DatiDiLaboratorio.pos")}
                                                         value={"01"}
                                                         newRadio={true}
                                                         onClick={this.riceviValoreInput}
                                                         checked={this.state.datiDiLaboratorio.hevRnaSiero === "01"}
                                            />
                                            <RadioButton id={"hevRnaSieroNo"}
                                                         name={"hevRnaSiero"}
                                                         label={t("SchedaSpecialeEpatiteE.DatiDiLaboratorio.neg")}
                                                         value={"02"}
                                                         newRadio={true}
                                                         onClick={this.riceviValoreInput}
                                                         checked={this.state.datiDiLaboratorio.hevRnaSiero === "02"}
                                            />
                                            <RadioButton id={"hevRnaSieroNonSo"}
                                                         name={"hevRnaSiero"}
                                                         label={t("SchedaSpecialeEpatiteE.DatiDiLaboratorio.nonRicercato")}
                                                         value={"03"}
                                                         newRadio={true}
                                                         onClick={this.riceviValoreInput}
                                                         checked={this.state.datiDiLaboratorio.hevRnaSiero === "03"}
                                            />
                                        </div>
                                    </div>
                                    <div className={"col-lg-4"}>
                                        <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                            {t("SchedaSpecialeEpatiteE.DatiDiLaboratorio.hevRnaFeci")}
                                            <span className={styles.mandatoryColor}>*</span>
                                        </p>
                                        <div className={"row"}>
                                            <RadioButton id={"hevRnaFeciSi"}
                                                         name={"hevRnaFeci"}
                                                         label={t("SchedaSpecialeEpatiteE.DatiDiLaboratorio.pos")}
                                                         value={"01"}
                                                         newRadio={true}
                                                         onClick={this.riceviValoreInput}
                                                         checked={this.state.datiDiLaboratorio.hevRnaFeci === "01"}
                                            />
                                            <RadioButton id={"hevRnaFeciNo"}
                                                         name={"hevRnaFeci"}
                                                         label={t("SchedaSpecialeEpatiteE.DatiDiLaboratorio.neg")}
                                                         value={"02"}
                                                         newRadio={true}
                                                         onClick={this.riceviValoreInput}
                                                         checked={this.state.datiDiLaboratorio.hevRnaFeci === "02"}
                                            />
                                            <RadioButton id={"hevRnaFeciNonSo"}
                                                         name={"hevRnaFeci"}
                                                         label={t("SchedaSpecialeEpatiteE.DatiDiLaboratorio.nonRicercato")}
                                                         value={"03"}
                                                         newRadio={true}
                                                         onClick={this.riceviValoreInput}
                                                         checked={this.state.datiDiLaboratorio.hevRnaFeci === "03"}
                                            />
                                        </div>
                                    </div>

                                    <div className={`col-lg-4 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'visualizzazione livello1' : ''}`}>
                                        <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                            {t("SchedaSpecialeEpatiteE.DatiDiLaboratorio.genotipo")}
                                        </p>
                                        <div className={"row"}>
                                            <Input
                                                id={"genotipo"}
                                                onChange={this.riceviValoreInput}
                                                field={"genotipo"}
                                                value={this.state.datiDiLaboratorio.genotipo}
                                                placeholder={"Genotipo"}
                                                disabled={(this.state.datiDiLaboratorio.hevRnaFeci !== "01") || (this.state.datiDiLaboratorio.hevRnaSiero !== "01")}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className={"row"}>
                                    <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                        {t("SchedaSpecialeEpatiteE.DatiDiLaboratorio.valMax")}
                                    </p>
                                </div>

                                <div className={"row"}>
                                    <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'visualizzazione livello4' : ''}`}>
                                        <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                            {t("SchedaSpecialeEpatiteE.DatiDiLaboratorio.astGpt")}
                                        </p>
                                        <div className={"row"}>
                                            <div className={"col-7"}>
                                                <Input
                                                    id={"astGpt"}
                                                    type="number" min="0" max="9998"
                                                    onChange={this.riceviValoreInput}
                                                    field={"astGpt"}
                                                    value={this.state.datiDiLaboratorio.astGpt}
                                                    placeholder={t("SchedaSpecialeEpatiteE.DatiDiLaboratorio.astGpt")}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'visualizzazione livello3' : ''}`}>
                                        <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                            {t("SchedaSpecialeEpatiteE.DatiDiLaboratorio.bilirubinaTotale")}
                                        </p>
                                        <div className={"row"}>
                                            <div className={"col-7"}>
                                                <Input
                                                    id={"bilirubinaTotale"}
                                                    type="number"
                                                    step="0.01"
                                                    min="0.01"
                                                    max="99.98"
                                                    onChange={this.riceviValoreInput}
                                                    field={"bilirubinaTotale"}
                                                    value={this.state.datiDiLaboratorio.bilirubinaTotale}
                                                    placeholder={t("SchedaSpecialeEpatiteE.DatiDiLaboratorio.bilirubinaTotale")}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'visualizzazione livello2' : ''}`}>
                                        <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                            {t("SchedaSpecialeEpatiteE.DatiDiLaboratorio.altGot")}
                                        </p>
                                        <div className={"row"}>
                                            <div className={"col-7"}>
                                                <Input
                                                    id={"altGot"}
                                                    type="number" min="0" max="9998"
                                                    onChange={this.riceviValoreInput}
                                                    field={"altGot"}
                                                    value={this.state.datiDiLaboratorio.altGot}
                                                    placeholder={t("SchedaSpecialeEpatiteE.DatiDiLaboratorio.altGot")}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'visualizzazione livello1' : ''}`}>
                                        <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                            {t("SchedaSpecialeEpatiteE.DatiDiLaboratorio.bilirubinaDiretta")}
                                        </p>
                                        <div className={"row"}>
                                            <div className={"col-7"}>
                                                <Input
                                                    id={"bilirubinaDiretta"}
                                                    type="number"
                                                    step="0.01"
                                                    min="0.01"
                                                    max="99.98"
                                                    onChange={this.riceviValoreInput}
                                                    field={"bilirubinaDiretta"}
                                                    value={this.state.datiDiLaboratorio.bilirubinaDiretta}
                                                    placeholder={t("SchedaSpecialeEpatiteE.DatiDiLaboratorio.bilirubinaDiretta")}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className={"row"}>
                                    <div className={"col-lg-4"}>
                                        <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                            {t("SchedaSpecialeEpatiteE.DatiDiLaboratorio.antiHbc")}
                                        </p>
                                        <div className={"row"}>
                                            <RadioButton id={"antiHbcSi"}
                                                         name={"antiHbc"}
                                                         label={t("SchedaSpecialeEpatiteE.DatiDiLaboratorio.pos")}
                                                         value={"01"}
                                                         newRadio={true}
                                                         onClick={this.riceviValoreInput}
                                                         checked={this.state.datiDiLaboratorio.antiHbc === "01"}
                                            />
                                            <RadioButton id={"antiHbcNo"}
                                                         name={"antiHbc"}
                                                         label={t("SchedaSpecialeEpatiteE.DatiDiLaboratorio.neg")}
                                                         value={"02"}
                                                         newRadio={true}
                                                         onClick={this.riceviValoreInput}
                                                         checked={this.state.datiDiLaboratorio.antiHbc === "02"}
                                            />
                                            <RadioButton id={"antiHbcNonSo"}
                                                         name={"antiHbc"}
                                                         label={t("SchedaSpecialeEpatiteE.DatiDiLaboratorio.nonRicercato")}
                                                         value={"03"}
                                                         newRadio={true}
                                                         onClick={this.riceviValoreInput}
                                                         checked={this.state.datiDiLaboratorio.antiHbc === "03"}
                                            />
                                        </div>
                                    </div>
                                    <div className={"col-lg-4"}>
                                        <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                            {t("SchedaSpecialeEpatiteE.DatiDiLaboratorio.igmHav")}
                                        </p>
                                        <div className={"row"}>
                                            <RadioButton id={"igmHavSi"}
                                                         name={"igmHav"}
                                                         label={t("SchedaSpecialeEpatiteE.DatiDiLaboratorio.pos")}
                                                         value={"01"}
                                                         newRadio={true}
                                                         onClick={this.riceviValoreInput}
                                                         checked={this.state.datiDiLaboratorio.igmHav === "01"}
                                            />
                                            <RadioButton id={"igmHavNo"}
                                                         name={"igmHav"}
                                                         label={t("SchedaSpecialeEpatiteE.DatiDiLaboratorio.neg")}
                                                         value={"02"}
                                                         newRadio={true}
                                                         onClick={this.riceviValoreInput}
                                                         checked={this.state.datiDiLaboratorio.igmHav === "02"}
                                            />
                                            <RadioButton id={"igmHavNonSo"}
                                                         name={"igmHav"}
                                                         label={t("SchedaSpecialeEpatiteE.DatiDiLaboratorio.nonRicercato")}
                                                         value={"03"}
                                                         newRadio={true}
                                                         onClick={this.riceviValoreInput}
                                                         checked={this.state.datiDiLaboratorio.igmHav === "03"}
                                            />
                                        </div>
                                    </div>
                                    <div className={"col-lg-4"}>
                                        <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                            {t("SchedaSpecialeEpatiteE.DatiDiLaboratorio.igmHbc")}
                                        </p>
                                        <div className={"row"}>
                                            <RadioButton id={"igmHbcSi"}
                                                         name={"igmHbc"}
                                                         label={t("SchedaSpecialeEpatiteE.DatiDiLaboratorio.pos")}
                                                         value={"01"}
                                                         newRadio={true}
                                                         onClick={this.riceviValoreInput}
                                                         checked={this.state.datiDiLaboratorio.igmHbc === "01"}
                                            />
                                            <RadioButton id={"igmHbcNo"}
                                                         name={"igmHbc"}
                                                         label={t("SchedaSpecialeEpatiteE.DatiDiLaboratorio.neg")}
                                                         value={"02"}
                                                         newRadio={true}
                                                         onClick={this.riceviValoreInput}
                                                         checked={this.state.datiDiLaboratorio.igmHbc === "02"}
                                            />
                                            <RadioButton id={"igmHbcNonSo"}
                                                         name={"igmHbc"}
                                                         label={t("SchedaSpecialeEpatiteE.DatiDiLaboratorio.nonRicercato")}
                                                         value={"03"}
                                                         newRadio={true}
                                                         onClick={this.riceviValoreInput}
                                                         checked={this.state.datiDiLaboratorio.igmHbc === "03"}
                                            />
                                        </div>
                                    </div>
                                </div>


                                <div className={"row"}>
                                    <div className={"col-lg-4"}>
                                        <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                            {t("SchedaSpecialeEpatiteE.DatiDiLaboratorio.hcv")}
                                        </p>
                                        <div className={"row"}>
                                            <RadioButton id={"hcvSi"}
                                                         name={"hcv"}
                                                         label={t("SchedaSpecialeEpatiteE.DatiDiLaboratorio.pos")}
                                                         value={"01"}
                                                         newRadio={true}
                                                         onClick={this.riceviValoreInput}
                                                         checked={this.state.datiDiLaboratorio.hcv === "01"}
                                            />
                                            <RadioButton id={"hcvNo"}
                                                         name={"hcv"}
                                                         label={t("SchedaSpecialeEpatiteE.DatiDiLaboratorio.neg")}
                                                         value={"02"}
                                                         newRadio={true}
                                                         onClick={this.riceviValoreInput}
                                                         checked={this.state.datiDiLaboratorio.hcv === "02"}
                                            />
                                            <RadioButton id={"hcvNonSo"}
                                                         name={"hcv"}
                                                         label={t("SchedaSpecialeEpatiteE.DatiDiLaboratorio.nonRicercato")}
                                                         value={"03"}
                                                         newRadio={true}
                                                         onClick={this.riceviValoreInput}
                                                         checked={this.state.datiDiLaboratorio.hcv === "03"}
                                            />
                                        </div>
                                    </div>
                                    <div className={"col-lg-4"}>
                                        <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                            {t("SchedaSpecialeEpatiteE.DatiDiLaboratorio.hbsAg")}
                                        </p>
                                        <div className={"row"}>
                                            <RadioButton id={"hbsAgSi"}
                                                         name={"hbsAg"}
                                                         label={t("SchedaSpecialeEpatiteE.DatiDiLaboratorio.pos")}
                                                         value={"01"}
                                                         newRadio={true}
                                                         onClick={this.riceviValoreInput}
                                                         checked={this.state.datiDiLaboratorio.hbsAg === "01"}
                                            />
                                            <RadioButton id={"hbsAgNo"}
                                                         name={"hbsAg"}
                                                         label={t("SchedaSpecialeEpatiteE.DatiDiLaboratorio.neg")}
                                                         value={"02"}
                                                         newRadio={true}
                                                         onClick={this.riceviValoreInput}
                                                         checked={this.state.datiDiLaboratorio.hbsAg === "02"}
                                            />
                                            <RadioButton id={"hbsAgNonSo"}
                                                         name={"hbsAg"}
                                                         label={t("SchedaSpecialeEpatiteE.DatiDiLaboratorio.nonRicercato")}
                                                         value={"03"}
                                                         newRadio={true}
                                                         onClick={this.riceviValoreInput}
                                                         checked={this.state.datiDiLaboratorio.hbsAg === "03"}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-4">
                                        <p className={styles.labelHeader} style={{color: "#1b7ea9", marginTop: "10px"}}>
                                            {t("SchedaSpecialeEpatiteE.DatiDiLaboratorio.hcvRna")}
                                        </p>
                                        <div className={"row"}>
                                            <RadioButton id={"hcvRnaSi"}
                                                         name={"hcvRna"}
                                                         label={t("SchedaSpecialeEpatiteE.DatiDiLaboratorio.pos")}
                                                         value={"01"}
                                                         newRadio={true}
                                                         onClick={this.riceviValoreInput}
                                                         checked={this.state.datiDiLaboratorio.hcvRna === "01"}
                                            />
                                            <RadioButton id={"hcvRnaNo"}
                                                         name={"hcvRna"}
                                                         label={t("SchedaSpecialeEpatiteE.DatiDiLaboratorio.neg")}
                                                         value={"02"}
                                                         newRadio={true}
                                                         onClick={this.riceviValoreInput}
                                                         checked={this.state.datiDiLaboratorio.hcvRna === "02"}
                                            />
                                            <RadioButton id={"hcvRnaNonSo"}
                                                         name={"hcvRna"}
                                                         label={t("SchedaSpecialeEpatiteE.DatiDiLaboratorio.nonRicercato")}
                                                         value={"03"}
                                                         newRadio={true}
                                                         onClick={this.riceviValoreInput}
                                                         checked={this.state.datiDiLaboratorio.hcvRna === "03"}
                                            />
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withTranslation('common')(DatiDiLaboratorio)
